import { Button } from 'primereact/button';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { CardBar } from '../card-bar/card-bar';
import { MindmapSelection } from './mindmap-selection';

export const MenuBar = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 530px)' });

  const buttonClasses = 'flex-none flex p-button-rounded p-button-secondary';

  return (
    <CardBar centered={false} position="top">
      <div className="flex gap-1 md:gap-2">
        <Button icon="pi pi-angle-left" className={buttonClasses} />
        <MindmapSelection
          className="flex-grow-1 flex"
          style={isMobile ? { maxWidth: '100%', width: 50 } : { maxWidth: 325 }}
        />
        {!isMobile && <Button icon="pi pi-download" className={buttonClasses} />}
        <Button icon="pi pi-user-plus" className={buttonClasses} />
      </div>
    </CardBar>
  );
};
